<template>
    <div class="main-content">
        <div class="uk-padding">
            <h1>Foto's</h1>
            <imageUploader></imageUploader>
            <div class="uk-child-width-1-4@m" uk-grid>
                <div v-if="!m.processed && !m.error" v-for="(m, id) in media">
                    <div class="uk-card uk-card-default">
                        <div class="uk-card-body">
                            <div class="spinner-container">
                                <svg class="spinner spinner-dark" viewBox="0 0 50 50">
                                    <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                </svg>
                            </div>
                            
                            <div class="clear"></div>
                        </div>
                        <div v-if="$store.state.core.user.role >= 3" class="uk-card-badge uk-label" @click="deleteProcessingImage(id)" :class="'uk-label-danger'">
                            <span uk-icon="trash"></span>
                        </div>
                    </div>
                </div>
                <div v-if="m.processed &!m.error" v-for="(m, id) in media">
                    <a href="#image-edit" @click="select(id)" uk-toggle>
                        <div class="uk-card uk-card-default">
                            <div class="uk-card-media-top">
                                <img :src="m.small" alt="">
                            </div>
                            <div class="uk-card-badge uk-label" :class="(m.placeholder && m.small && m.medium && m.large && m.extralarge) ? 'uk-label-success' : 'uk-label-danger'">
                                <span uk-icon="check"></span>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
        <div id="image-edit" uk-modal>
            <div class="uk-modal-dialog" v-if="selected">
                <button class="uk-modal-close-default" type="button" uk-close></button>
                <div class="uk-modal-header">
                    <h2 class="uk-modal-title">Afbeelding bewerken</h2>
                </div>
                <div class="uk-modal-body">
                    <div class="uk-align-left">
                        <img :src="media[selected].small"/>
                    </div>
                </div>
                <div class="uk-modal-footer uk-text-right">
                    <button v-if="$store.state.core.user.role >= 3" class="uk-button uk-button-danger uk-modal-close" @click.prevent="deleteImage(selected)" type="button">Verwijderen</button>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import {db, storage} from '@/CUSTOM/helpers/firebase'
import imageUploader from '@/CORE/modules/MEDIA/ImageUploader'
export default {
    name:'MediaOverview',
    components: {imageUploader},
    data () {
        return {
            media: null,
            selected: null,
            formats: ['placeholder', 'small', 'medium', 'large', 'extralarge', 'url']
        }
    },
    created () {
        db.collection('media').onSnapshot((snap) => {
            this.media = {}
            snap.forEach((doc) => {
                this.media[doc.id] = doc.data()
            })
        })
    },
    methods: {
        select (id) {
            this.selected = id
        },
        save () {
            db.collection('media').doc(this.selected).update(this.media[this.selected]).then(success => {
                this.$store.dispatch('PUSH_NOTIFICATION', {message: 'Afbeelding data aangepast', status: 'success'})
                this.selected = null
            }).catch(error => {
                throw error;
            })
        },
        deleteImage (id) {
            if(this.$store.state.core.user.role >= 3) {
                UIkit.modal.confirm('Ben je zeker dat je deze foto wil verwijderen?').then(() => {
                    var promise = []
                    for (var f in this.formats) {
                        if(storage.refFromURL(this.media[id][this.formats[f]])) {
                            promise.push(storage.refFromURL(this.media[id][this.formats[f]]).delete())
                        }
                        
                    }
                    Promise.all(promise).then(success => {
                        this.selected = null
                        return db.collection('media').doc(id).delete()
                    }).then(success => {
                        this.$store.dispatch('PUSH_NOTIFICATION', {message: 'Foto verwijderd', status: 'danger'})
                    }).catch(error => {
                        this.$store.dispatch('PUSH_NOTIFICATION', {message: 'Er ging iets fout...', status: 'danger'})
                        throw error
                    })  
                }, () => {
                    console.log('Rejected.')
                });
                
            }          
        },
        deleteProcessingImage (id) {
            if(this.$store.state.core.user.role >= 3) {
                UIkit.modal.confirm('Deze foto is nog aan het verwerken, ben je zeker dat je dit wilt annuleren?').then(() => {
                    var promise = []
                    var m = this.media[id]
                    for (var f in this.formats) {
                        if(m[f] != undefined && storage.refFromURL(this.media[id][this.formats[f]])) {
                            promise.push(storage.refFromURL(this.media[id][this.formats[f]]).delete())
                        }
                        
                    }
                    Promise.all(promise).then(success => {
                        return db.collection('media').doc(id).delete()
                    }).then(success => {
                        this.$store.dispatch('PUSH_NOTIFICATION', {message: 'Foto verwijderd', status: 'danger'})
                    }).catch(error => {
                        this.$store.dispatch('PUSH_NOTIFICATION', {message: 'Er ging iets fout...', status: 'danger'})
                        throw error
                    })  
                }, () => {
                    console.log('Rejected.')
                });
                
            }     
        }
    }
}
</script>
<style>
    .uk-card-badge {
        top: 10px !important;
        right: 10px !important;
    }
</style>


// WEBPACK FOOTER //
// Overview.vue?39ab3517